var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ellipsis
    ? _c(
        "span",
        {
          ref: "span1",
          staticClass: "line-label overflow-ellipsis",
          attrs: { title: _vm.label }
        },
        [_vm._v(_vm._s(_vm.label))]
      )
    : _c("span", { ref: "span2", staticClass: "line-label" }, [
        _vm._v(_vm._s(_vm.label))
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }